export const getAvailableIntegrationsUrl = (workspaceId: string) =>
  `/business/workspaces/${workspaceId}/available_integrations`;

export const getNewIntegrationsUrl = (workspaceId: string) => `/business/workspaces/${workspaceId}/integrations/new`;

export const getIntegrationsUrl = (workspaceId: string) => `/business/workspaces/${workspaceId}/integrations`;

export const getUpdateIntegrationsUrl = (workspaceId: string, integrationId: string) =>
  `/business/workspaces/${workspaceId}/integrations/${integrationId}`;

export const getIntegrationUrl = (workspaceId: string, integrationId: number) =>
  `/business/workspaces/${workspaceId}/integrations/${integrationId}`;

export const getCalendersUrl = (workspaceId: string, id: number) =>
  `/business/workspaces/${workspaceId}/integrations/${id}/fetch_calendars`;

export const getOauthRedirectUrl = (code: string) => `/integrations/${code}/oauth_redirect`;
